import { Icon } from 'leaflet'
import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './registerServiceWorker'
import router from './router'
import store from './store'

import 'leaflet/dist/leaflet.css'
import { ApiService } from '@/services/api.service'
import i18n from './i18n'
import { City } from '@/services/city.service'
import { CityAPIModel } from '../models'

library.add(faHome)
library.add(faEnvelope)
library.add(faPhone)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(Buefy)

ApiService.init(`${process.env.VUE_APP_BACKEND_URL}/v1/`)

const initApp = () => {
  City.getCityConfig()
    .then((data: CityAPIModel) => {
      new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
        created () {
          this.$store.commit('updateZoom', 17)
          this.$store.commit('updateCenter',
            data.center.coordinates.reverse()
          )
          this.$store.commit('setCityName', data.name)
          this.$store.commit('setCityImage', data.image)
          this.$store.commit('setCityText', data.text)
          this.$store.commit('setCityUseCustomMessage', data.useCustomMessage)
          this.$store.commit('setCityCustomMessage', data.customMessage)
        }
      }).$mount('#app')
    })
    .catch(() => {
      console.log('Error fetching a city.')
    })
}

initApp()
